/* global System */
import withLazyUnveil from '../../higher-order-components/withLazyUnveil'

export default {
  ImageSlider: withLazyUnveil({
    loadComponent: () =>
      System.import(
        /* webpackChunkName: "ImageSlider" */
        './index'
      ),
    height: 800,
    mobileHeight: 260,
  }),
}
